import { createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import { toast } from "utils/toast";

import { setIsSpinnerVisible } from "store/modules/AppConfig/index.store";

import ordersApi from "services/ordersApi";
import i18next from "i18next";
import { parsePersistedDateFromObject } from "utils/parsePersistedDateFromObject";
import {
  OrderAddDriveRequest,
  OrderProps,
  OrderUpdateRequest,
} from "./types.store";

export const handleGetOrdersRequest = createAsyncThunk<null, string | null>(
  "getOrders",
  async (selectedDealer, { rejectWithValue, dispatch }) => {
    if (!selectedDealer) {
      return [];
    }

    try {
      dispatch(setIsSpinnerVisible(true));

      const { data } = await ordersApi.get(
        `v1/dealers/${selectedDealer}/orders?state=all`,
      );
      const finalData = data;

      finalData?.forEach((order: OrderProps) => {
        parsePersistedDateFromObject(order, "createdAt");
      });

      return finalData;
    } catch (err) {
      toast("Falha ao carregar os pedidos, tente novamente!", {
        type: "error",
      });

      if (Axios.isAxiosError(err) && err && err.response) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue(err);
    } finally {
      dispatch(setIsSpinnerVisible(false));
    }
  },
);

export const handleUpdateOrderRequest = createAsyncThunk<
  null,
  OrderUpdateRequest
>("updateOrder", async (data, { rejectWithValue, dispatch }) => {
  try {
    dispatch(setIsSpinnerVisible(true));

    const payload = data.body
      ? {
          ...data.body,
          reasonNotProvidePin: data.reasonNotProvidePin
            ? data.reasonNotProvidePin
            : undefined,
          pin: data.pin ? data.pin : undefined,
        }
      : {
          reasonNotProvidePin: data.reasonNotProvidePin
            ? data.reasonNotProvidePin
            : undefined,
          pin: data.pin ? data.pin : undefined,
          consumerId: data.consumerId,
          origin: "DealerPortal",
          eta: data?.eta ? data?.eta : null,
        };
    await ordersApi.post(
      `v1/dealers/${data.dealerId}/orders/${data.orderId}/${data.type}`,
      payload,
    );

    return null;
  } catch (err) {
    toast("Falha ao iniciar pedido, tente novamente!", {
      type: "error",
    });

    if (Axios.isAxiosError(err) && err && err.response) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err);
  } finally {
    dispatch(setIsSpinnerVisible(false));
  }
});

export const handleAddDriveOrderRequest = createAsyncThunk<
  null,
  OrderAddDriveRequest
>("updateOrder", async (data, { rejectWithValue, dispatch }) => {
  try {
    dispatch(setIsSpinnerVisible(true));

    if (data.clearDriver === true) {
      await ordersApi.put(
        `v1/dealers/${data.dealerId}/orders/${data.orderId}/driver`,
        { driver: {} },
      );
    } else {
      if (!data.driverId || !data.driverName) {
        return rejectWithValue(null);
      }
      await ordersApi.put(
        `v1/dealers/${data.dealerId}/orders/${data.orderId}/driver`,
        {
          driver: {
            id: data.driverId,
            name: data.driverName,
          },
        },
      );
    }

    return null;
  } catch (err) {
    toast(i18next.t("Não foi possivel adicionar motorista").toString(), {
      type: "error",
    });

    if (Axios.isAxiosError(err) && err && err.response) {
      return rejectWithValue(err.response.data);
    }
    return rejectWithValue(err);
  } finally {
    dispatch(setIsSpinnerVisible(false));
  }
});
